import { render, staticRenderFns } from "./SdsTableSection0DynamicList.vue?vue&type=template&id=6e6eb374&scoped=true"
import script from "./SdsTableSection0DynamicList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection0DynamicList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection0DynamicList.vue?vue&type=style&index=0&id=6e6eb374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6eb374",
  null
  
)

export default component.exports